
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';

import { Title } from 'src/onboarding/components/typography/Title/Title';

import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const weightlossExperience = useStore((state) => state.weightlossExperience);
  const setWeightlossExperience = useStore((state) => state.setWeightlossExperience);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.weightlossExperience.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={weightlossExperience}
          onChange={(value) => {
            setWeightlossExperience(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'weightloss-experience',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'I’ve lost weight but want to lose more'}>
            <span>💪</span> {t('onboarding.weightlossExperience.options.wantLoseMore')}
          </Option>
          <Option value={"My previous attempts weren’t successful"}>
            <span>😕</span> {t('onboarding.weightlossExperience.options.werentSuccessful')}
          </Option>
          <Option value={'I lost weight but gained it back'}>
            <span>🔁</span> {t('onboarding.weightlossExperience.options.gainedBack')}
          </Option>
           <Option value={'I’ve never tried losing weight before'}>
            <span>🌱</span> {t('onboarding.weightlossExperience.options.neverTried')}
          </Option>
        </Check>
      </div>
    </div>
  );
}

export default Page;
